<template>
  <ul class="d-flex align-items-center">
    <li
      v-if="phonenumber"
    >
      <a :href="'tel: ' + phonenumber.replace(' ', '').replace('-', '')" class="p-2">
        <i class="fa fa-phone pr-2"/>{{ phonenumber }}
      </a>
    </li>
    <li
      v-if="facebook"
    >
      <a :href="facebook" target="_blank" class="p-2"><i class="fa fa-facebook-f" /></a>
    </li>
    <li
      v-if="instagram"
    >
      <a :href="instagram" target="_blank" class="p-2"><i class="fa fa-instagram" /></a>
    </li>
    <li
      v-if="twitter"
    >
      <a :href="twitter" target="_blank" class="p-2"><i class="fa fa-twitter-square" /></a>
    </li>
    <li class="buheader-top__social-enjoj px-2">
      <a :href="'https://beta.enjoj-test.nl/community/surrounding/' + id" target="_blank">
        <span>
          <img src="@/assets/images/enjoj-logo.png" alt="ENJOJ">
        </span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ec-business-social',
  props: {
    facebook: {
      default: null
    },
    instagram: {
      default: null
    },
    phonenumber: {
      default: null
    },
    twitter: {
      default: null
    },
    id: {
      default: null
    }
  }
}
</script>
